import { FC } from 'react';
import {
  StyledModal,
  PopupTitle,
  ModalContent,
  Text,
  QuitEditingButton,
  KeepEditingButton,
  ButtonsContainer,
  CloseButton,
  CloseModalIcon,
  BackdropStyles
} from './quit-edit-popup.styles';

interface Props {
  isOpen: boolean;
  onQuitEditing: () => void;
  onKeepEditing: () => void;
}

export const QuitEditPopup: FC<Props> = ({ isOpen, onQuitEditing, onKeepEditing }) => {
  return (
    <StyledModal
      id='quit-edit-popup'
      open={isOpen}
      onClose={onKeepEditing}
      BackdropProps={BackdropStyles}
    >
      <ModalContent id='quit-edit-popup-content'>
        <CloseButton onClick={onKeepEditing} id='quit-edit-popup-top-close-button'>
          <CloseModalIcon />
        </CloseButton>
        <PopupTitle id='quit-edit-popup-title'>Quit editing?</PopupTitle>
        <Text id='quit-edit-popup-text'>
          Changes you have made so far will not be saved. <br /> Are you sure you want to quit?
        </Text>
        <ButtonsContainer id='quit-edit-popup-buttons'>
          <QuitEditingButton
            id='quit-edit-popup-quit-editing-button'
            onClick={() => {
              onQuitEditing();
            }}
          >
            Yes, quit editing
          </QuitEditingButton>
          <KeepEditingButton
            id='quit-edit-popup-keep-editing-button'
            onClick={() => {
              onKeepEditing();
            }}
          >
            Keep editing
          </KeepEditingButton>
        </ButtonsContainer>
      </ModalContent>
    </StyledModal>
  );
};
